<template>

	<button v-if="look=='sidebar'" type="button" class="button solid wide small accent" :style="'--accent:' + this.accent" v-on:click="togglePaymentForm()">
		<span class="fa-stack fa-1x">
			<i class="fal fa-circle fa-stack-2x"></i>
			<i class="fas fa-pound-sign fa-stack-1x"></i>
		</span>
		Make a Payment
	</button>

	<button v-else-if="look=='listing'" type="button" class="button medium textual arrow" v-on:click="togglePaymentForm()">Make a Payment</button>

	<button v-else-if="look=='deposit'" type="button" class="button solid wide small accent" :style="'--accent:' + this.accent" v-on:click="togglePaymentForm()">
		<span class="fa-stack fa-1x">
			<i class="fal fa-circle fa-stack-2x"></i>
			<i class="fas fa-pound-sign fa-stack-1x"></i>
		</span>
		Pay Deposit
	</button>

	<button v-else-if="look=='participant'" type="button" class="button small accent solid" :style="'margin-left: auto; --accent:' + this.accent" v-on:click="togglePaymentForm()">
		<span class="fa-stack fa-1x">
			<i class="fal fa-circle fa-stack-2x"></i>
			<i class="fas fa-pound-sign fa-stack-1x"></i>
		</span>
		Make a Payment
	</button>

	<button v-else-if="look=='dashboard'" type="button" class="button small solid" :style="'--accent:' + this.accent" v-on:click="togglePaymentForm()">
		<span class="fa-stack fa-1x">
			<i class="fal fa-circle fa-stack-2x"></i>
			<i class="fas fa-pound-sign fa-stack-1x"></i>
		</span>
		Make a Payment
	</button>

</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {

	props: [
		'uuid',
		'participant_id',
		'type',
		'look',
		'accent',
	],

	data: () => {
		return {
		}
	},

	computed: {
	},

	watch: {
	},

	created() {
	},

	mounted() {
	},

	methods: {

		togglePaymentForm: function(){
			this.$root.$refs.paymentform.togglePaymentForm(this.uuid, this.participant_id, this.type, this.accent);
		}

	}
};
</script>